
import React from "react";
import { StatCards } from "./StatCards";
import { RecentOrdersTable } from "./RecentOrdersTable";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { FactoryPerformance } from "./FactoryPerformance";
import { StatItem } from "@/hooks/dashboard/types";

export interface DashboardStats {
  totalOrders: number;
  pendingOrders: number;
  completedOrders: number;
  totalRevenue: number;
}

export interface Factory {
  id: string;
  name: string;
  location: string;
  capacity: number;
  performance: number;
}

export interface RecentOrder {
  id: string;
  order_number: string;
  customer_name: string;
  total_amount: number;
  status: "pending" | "completed" | "canceled" | "in-progress";
  created_at: string;
}

interface DashboardContentProps {
  stats: StatItem[];
  recentOrders: {
    id: string;
    customer: string;
    date: string;
    status: "pending" | "in-progress" | "completed" | "canceled";
    amount: string;
    factory: string;
  }[];
  factories: {
    name: string;
    completedOrders: number;
    pendingOrders: number;
    efficiency: number;
  }[];
}

export const DashboardContent: React.FC<DashboardContentProps> = ({
  stats,
  recentOrders,
  factories,
}) => {
  return (
    <div className="space-y-8">
      <StatCards stats={stats} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Card>
          <CardHeader>
            <CardTitle>Recent Orders</CardTitle>
            <CardDescription>
              Latest customer orders and their status
            </CardDescription>
          </CardHeader>
          <CardContent>
            <RecentOrdersTable orders={recentOrders} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Factory Performance</CardTitle>
            <CardDescription>
              Production capacity utilization by factory
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FactoryPerformance factories={factories} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
